export default "__VITE_ASSET___V8V1EpQ__"